<template>
  <div
    class="flex flex-col md:flex-row flex-wrap gap-2"
    role="radiogroup"
    aria-labelledby="radioGroupLabel"
  >
    <div
      v-for="option in options"
      :key="option.name"
      class="child"
      data-testId="radio"
    >
      <div
        class="p-4 rounded-sm duration-300 group cursor-pointer flex justify-center items-center"
        :class="{
          'bg-primary': model === option.name,
          'bg-slate-onyx': model !== option.name,
          'hover:bg-opacity-10': model !== option.name,
          'hover:bg-frosty-dawn': model !== option.name
        }"
        tabindex="0"
        role="radio"
        :aria-checked="model === option.name"
        :aria-labelledby="`label-${option.id}`"
        @click="selectOption(option.name)"
        @keydown.space.prevent="onKeyPress($event, option.name)"
        @keydown.enter.prevent="onKeyPress($event, option.name)"
      >
        <input
          :id="option.id"
          v-model="model"
          type="radio"
          class="hidden"
          :name="name"
          :value="option.name"
          tabindex="-1"
        />
        <label
          class="font-base font-normal duration-300 cursor-pointer"
          :for="option.id"
          :class="{
            'text-dark1': model === option.name,
            'text-white': model !== option.name,
            'group-hover:text-primary': model !== option.name
          }"
          >{{ option.label }}</label
        >
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  interface Option {
    id: string;
    name: string;
    label: string;
  }

  interface Props {
    id: string;
    name: string;
    options: Option[];
  }

  const model = defineModel<string>();
  defineProps<Props>();

  const selectOption = (value: string) => {
    model.value = value;
  };

  const onKeyPress = (event: KeyboardEvent, value: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      selectOption(value);
    }
  };
</script>

<style lang="scss" scoped>
  .child {
    flex: 1 0 calc(33.333% - 10px);
  }
</style>
